// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-button {
  font-family: "Roboto-Medium";
}

.px-16px {
  padding-left: 16px;
  padding-right: 16px;
}

.py-16px {
  padding-top: 16px;
  padding-bottom: 16px;
}

.p-16px {
  padding: 16px;
}

.pr-16px {
  padding-right: 16px !important;
  padding-inline-end: 16px !important;
}

.pl-16px {
  padding-left: 16px !important;
  padding-inline-start: 16px !important;
}

.pb-16px {
  padding-bottom: 16px;
}

.pt-16px {
  padding-top: 16px;
  --padding-top: 16px;
}

.m-0 {
  margin: 0 !important;
}

.p-0 {
  padding: 0 !important;
}

.d-f-a-c {
  align-items: center;
  display: flex;
}

.three-dots {
  display: block;
  text-overflow: ellipsis;
  overflow: hidden;
  width: 100%;
  height: 100%;
  white-space: nowrap;
}

h2 {
  margin-bottom: 16px;
  margin-top: 32px;
  text-align: left;
}

.wrapper-block {
  background: #F2F2F0;
  --border: none;
  padding: 16px;
  border-bottom: 1px solid #dfdfdf;
}
.wrapper-block .facility {
  font-size: 1rem;
  font-family: "Roboto-Medium";
  color: var(--vl-black);
  text-align: left;
}
.wrapper-block .facility span {
  color: #b5b5bc;
  font-size: 0.9rem;
}
.wrapper-block .duration {
  font-family: "Roboto-Regular";
  font-size: 0.75rem;
  color: var(--vl-black-font);
  text-align: left;
}
.wrapper-block .costs {
  text-align: right;
}
.wrapper-block .costs .text {
  font-family: "Roboto-Regular";
  font-size: 0.75rem;
  color: var(--vl-black-font);
  font-weight: 400;
}
.wrapper-block .costs .price {
  font-size: 1rem;
  font-family: "Roboto-Medium";
  font-weight: 500;
  color: var(--vl-red);
}
.wrapper-block .from-to {
  display: flex;
  padding-top: 16px;
}
.wrapper-block .from-to .from, .wrapper-block .from-to .to {
  width: 40%;
  padding: 10px;
  border: 1px solid #A7A7AE;
  border-radius: 10px;
}
.wrapper-block .from-to .from .text, .wrapper-block .from-to .to .text {
  font-size: 0.75rem;
  text-align: left;
  color: #A7A7AE;
}
.wrapper-block .from-to .from .date, .wrapper-block .from-to .to .date {
  font-size: 0.9rem;
  font-family: "Roboto-Regular";
  color: var(--vl-black);
  text-align: left;
}
.wrapper-block .from-to .arrow {
  width: 20%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.wrapper-block .from-to .arrow .arrow-right {
  stroke: #A7A7AE;
}
.wrapper-block .from-to .arrow .arrow-right ::ng-deep svg {
  fill: #A7A7AE;
}
.wrapper-block p {
  margin: 0;
  padding: 8px 16px;
  font-size: 0.9rem;
  font-family: "Roboto-Regular";
  text-align: left;
}
.wrapper-block.ACCEPTED {
  background-color: #FCFEE9;
}
.wrapper-block.ACCEPTED ion-badge {
  background-color: rgba(43, 161, 77, 0.12);
  color: var(--vl-green);
}
.wrapper-block.REJECTED ion-badge {
  background-color: #DDDEE3;
  color: #58585F;
}
.wrapper-block.STOPPED ion-badge {
  background-color: #DDDEE3;
  color: #58585F;
}
.wrapper-block.EXPIRED ion-badge {
  background-color: #DDDEE3;
  color: #58585F;
}

.col-4 {
  padding-left: 15px;
  padding-right: 15px;
  align-items: center;
  display: flex;
  justify-content: flex-end;
}
.col-4 ion-badge {
  font-size: 0.75rem;
  height: 23px;
  line-height: 13px;
  padding: 5px 10px;
  border-radius: 30px;
}`, "",{"version":3,"sources":["webpack://./src/assets/scss/_vl-variables.scss","webpack://./src/app/modules/shared-booking-access/pages/shared-bookings-access-list/components/booking-access-item/booking-access-item.component.scss"],"names":[],"mappings":"AAgBA;EACE,4BAXc;ACJhB;;ADmBA;EACE,kBAZe;EAaf,mBAbe;ACHjB;;ADmBA;EACE,iBAjBe;EAkBf,oBAlBe;ACEjB;;ADmBA;EACE,aAtBe;ACMjB;;ADmBA;EACE,8BAAA;EACA,mCAAA;AChBF;;ADmBA;EACE,6BAAA;EACA,qCAAA;AChBF;;ADmBA;EACE,oBAAA;AChBF;;ADmBA;EACE,iBAAA;EACA,mBAAA;AChBF;;ADmBA;EACE,oBAAA;AChBF;;ADmBA;EACE,qBAAA;AChBF;;ADmBA;EACE,mBAAA;EACA,aAAA;AChBF;;ADmBA;EACE,cAAA;EACA,uBAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;AChBF;;AAvDA;EACE,mBAAA;EACA,gBAAA;EACA,gBAAA;AA0DF;;AAvDA;EACE,mBAAA;EACA,cAAA;EAEA,aAAA;EACA,gCAAA;AAyDF;AAvDE;EACE,eAAA;EACA,4BDXY;ECYZ,sBAAA;EACA,gBAAA;AAyDJ;AAvDI;EACE,cAAA;EACA,iBAAA;AAyDN;AArDE;EACE,6BDpBa;ECqBb,kBAAA;EACA,2BAAA;EACA,gBAAA;AAuDJ;AApDE;EACE,iBAAA;AAsDJ;AApDI;EACE,6BD9BW;EC+BX,kBAAA;EACA,2BAAA;EACA,gBAAA;AAsDN;AAnDI;EACE,eAAA;EACA,4BDxCU;ECyCV,gBAAA;EACA,oBAAA;AAqDN;AAjDE;EACE,aAAA;EACA,iBAAA;AAmDJ;AAjDI;EACE,UAAA;EACA,aAAA;EACA,yBAAA;EACA,mBAAA;AAmDN;AAjDM;EACE,kBAAA;EACA,gBAAA;EACA,cAAA;AAmDR;AAhDM;EACE,iBAAA;EACA,6BD9DS;EC+DT,sBAAA;EACA,gBAAA;AAkDR;AA9CI;EACE,UAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAgDN;AA9CM;EACE,eAAA;AAgDR;AA9CQ;EACE,aAAA;AAgDV;AA1CE;EACE,SAAA;EACA,iBAAA;EACA,iBAAA;EACA,6BDxFa;ECyFb,gBAAA;AA4CJ;AApCE;EACE,yBAAA;AAsCJ;AApCI;EACE,yCAAA;EACA,sBAAA;AAsCN;AAjCI;EACE,yBAAA;EACA,cAAA;AAmCN;AA9BI;EACE,yBAAA;EACA,cAAA;AAgCN;AA3BI;EACE,yBAAA;EACA,cAAA;AA6BN;;AAxBA;EACE,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,aAAA;EACA,yBAAA;AA2BF;AAzBE;EACE,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,iBAAA;EACA,mBAAA;AA2BJ","sourcesContent":["$red: #EB0000;\n$black: #262627;\n\n$font-path: \"~roboto-fontface/fonts/roboto/\";\n$font-format: 'woff';\n$roboto-bold: \"Roboto-Bold\";\n$roboto-medium: \"Roboto-Medium\";\n$roboto-light: \"Roboto-Light\";\n$roboto-regular: \"Roboto-Regular\";\n\n$global-padding: 16px;\n$global-padding-with-fixed-button: 108px;\n$toolbar-height: 70px;\n$modal-height: 425px;\n$edit-phone-email-modal-height: 325px;\n\nion-button {\n  font-family: $roboto-medium;\n}\n\n\n.px-16px {\n  padding-left: $global-padding;\n  padding-right: $global-padding;\n}\n\n.py-16px {\n  padding-top: $global-padding;\n  padding-bottom: $global-padding;\n}\n\n.p-16px {\n  padding: $global-padding;\n}\n\n.pr-16px {\n  padding-right: $global-padding !important;\n  padding-inline-end: $global-padding !important;\n}\n\n.pl-16px {\n  padding-left: $global-padding !important;\n  padding-inline-start: $global-padding !important;\n}\n\n.pb-16px {\n  padding-bottom: 16px;\n}\n\n.pt-16px {\n  padding-top: 16px;\n  --padding-top: 16px;\n}\n\n.m-0 {\n  margin: 0 !important;\n}\n\n.p-0 {\n  padding: 0 !important;\n}\n\n.d-f-a-c {\n  align-items: center;\n  display: flex;\n}\n\n.three-dots {\n  display: block;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  width: 100%;\n  height: 100%;\n  white-space: nowrap;\n}\n","@use \"/src/assets/scss/vl-variables\" as *;\n\nh2 {\n  margin-bottom: 16px;\n  margin-top: 32px;\n  text-align: left;\n}\n\n.wrapper-block {\n  background: #F2F2F0;\n  --border: none;\n  //margin: 0 -15px;\n  padding: 16px;\n  border-bottom: 1px solid #dfdfdf;\n\n  .facility {\n    font-size: 1rem;\n    font-family: $roboto-medium;\n    color: var(--vl-black);\n    text-align: left;\n\n    span {\n      color: #b5b5bc;\n      font-size: 0.9rem;\n    }\n  }\n\n  .duration {\n    font-family: $roboto-regular;\n    font-size: 0.75rem;\n    color: var(--vl-black-font);\n    text-align: left;\n  }\n\n  .costs {\n    text-align: right;\n\n    .text {\n      font-family: $roboto-regular;\n      font-size: 0.75rem;\n      color: var(--vl-black-font);\n      font-weight: 400;\n    }\n\n    .price {\n      font-size: 1rem;\n      font-family: $roboto-medium;\n      font-weight: 500;\n      color: var(--vl-red);\n    }\n  }\n\n  .from-to {\n    display: flex;\n    padding-top: 16px;\n\n    .from, .to {\n      width: 40%;\n      padding: 10px;\n      border: 1px solid #A7A7AE;\n      border-radius: 10px;\n\n      .text {\n        font-size: 0.75rem;\n        text-align: left;\n        color: #A7A7AE;\n      }\n\n      .date {\n        font-size: 0.9rem;\n        font-family: $roboto-regular;\n        color: var(--vl-black);\n        text-align: left;\n      }\n    }\n\n    .arrow {\n      width: 20%;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n\n      .arrow-right {\n        stroke: #A7A7AE;\n\n        ::ng-deep svg {\n          fill: #A7A7AE;\n        }\n      }\n    }\n  }\n\n  p {\n    margin: 0;\n    padding: 8px 16px;\n    font-size: 0.9rem;\n    font-family: $roboto-regular;\n    text-align: left;\n  }\n\n\n  &.INVITED {\n\n  }\n\n  &.ACCEPTED {\n    background-color: #FCFEE9;\n\n    ion-badge {\n      background-color: rgba(43, 161, 77, 0.12);\n      color: var(--vl-green);\n    }\n  }\n\n  &.REJECTED {\n    ion-badge {\n      background-color: #DDDEE3;\n      color: #58585F;\n    }\n  }\n\n  &.STOPPED {\n    ion-badge {\n      background-color: #DDDEE3;\n      color: #58585F;\n    }\n  }\n\n  &.EXPIRED {\n    ion-badge {\n      background-color: #DDDEE3;\n      color: #58585F;\n    }\n  }\n}\n\n.col-4 {\n  padding-left: 15px;\n  padding-right: 15px;\n  align-items: center;\n  display: flex;\n  justify-content: flex-end;\n\n  ion-badge {\n    font-size: 0.75rem;\n    height: 23px;\n    line-height: 13px;\n    padding: 5px 10px;\n    border-radius: 30px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
